import React, { useState } from 'react';
import EditBar from 'modules/subscription-settings/container/EditBar';
import Header from 'partial/Header';
import Sidebar from 'partial/Sidebar';
import ModuleWrapper, { ModuleLabel } from 'partial/wrappers/ModuleWrapper';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import IdleTimerModal from 'partial/components/IdleTimerModal';
import { PlansProvider } from './wrappers/PlansContext';

function Layout() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ModuleWrapper>
      <PlansProvider>
        <div>
          <IdleTimerModal />
          {/*
            The sidebar owns a 64px masthead, so the header spans only the
            content column and the two hairlines meet. Was: header full-width
            above a `calc(100vh - 84px)` row, while the header actually
            measured 94px.
          */}
          <div className="h-screen flex overflow-hidden bg-neutral-50">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            <div className="flex-1 min-w-0 flex flex-col">
              <Header isOpen={isOpen} setIsOpen={setIsOpen} />
              <div className="flex-1 min-h-0">
                <Scrollbars autoHide>
                  <main className="flex-1 relative focus:outline-none flex flex-col z-10">
                    <div className="w-full py-6 px-4 lg:px-8 flex flex-col">
                      <ModuleLabel />
                      <div className="flex-auto">
                        <Outlet />
                      </div>
                    </div>
                  </main>
                </Scrollbars>
              </div>
            </div>
          </div>
          <Routes>
            <Route
              path="/settings/plans/:planId/update-plan"
              element={<EditBar />}
            />
          </Routes>
        </div>
      </PlansProvider>
    </ModuleWrapper>
  );
}

export default Layout;
